export default __webpack_public_path__ + "static/media/reward-coin.6959314f.webp";